"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumbers = void 0;
var react_1 = __importDefault(require("react"));
var LimitTextField_1 = require("./LimitTextField");
var styles_1 = require("@material-ui/core/styles");
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var strings_1 = __importDefault(require("../strings"));
var utils_1 = require("../utils");
var useStyles = styles_1.makeStyles(function (theme) { return ({
    error: {
        color: "Red",
        marginTop: theme.spacing(-2),
    },
}); });
var PhoneNumbers = function (props) {
    var classes = useStyles(props);
    var _a = react_1.default.useState(props.phone_number || ""), homePhone = _a[0], setHomePhone = _a[1];
    var _b = react_1.default.useState(props.work_phone_number || ""), workPhone = _b[0], setWorkPhone = _b[1];
    var _c = react_1.default.useState(props.cell_phone_number || ""), cellPhone = _c[0], setCellPhone = _c[1];
    var _d = react_1.default.useState(!!props.can_text), canText = _d[0], setCanText = _d[1];
    var _e = react_1.default.useState(props.primary_phone || null), primaryPhone = _e[0], setPrimaryPhone = _e[1];
    react_1.default.useEffect(function () {
        setHomePhone(props.phone_number || "");
        setWorkPhone(props.work_phone_number || "");
        setCellPhone(props.cell_phone_number || "");
        setCanText(!!props.can_text);
        setPrimaryPhone(props.primary_phone || null);
    }, [props.phone_number, props.work_phone_number, props.cell_phone_number, props.can_text, props.primary_phone]);
    var handleChangeNumber = function (e) {
        var home = homePhone;
        var work = workPhone;
        var cell = cellPhone;
        var primary = primaryPhone;
        var regexPattern = /^[0-9-+()]*$/;
        if (e.target.value === "" || regexPattern.test(e.target.value)) {
            switch (e.target.name) {
                case "work_phone_number":
                    work = e.target.value;
                    primary = (props.showPrimary && !primary) ? "work" : primaryPhone;
                    setWorkPhone(work);
                    break;
                case "home_phone_number":
                    home = e.target.value;
                    primary = (props.showPrimary && !primary) ? "home" : primaryPhone;
                    setHomePhone(home);
                    break;
                case "cell_phone_number":
                    cell = e.target.value;
                    primary = (props.showPrimary && !primary) ? "cell" : primaryPhone;
                    setCellPhone(cell);
                    break;
            }
            setPrimaryPhone(primary);
            props.onChange(home, work, cell, canText, primary);
        }
    };
    var handleBlurNumber = function (e) {
        var home = homePhone;
        var work = workPhone;
        var cell = cellPhone;
        switch (e.target.name) {
            case "work_phone_number":
                work = utils_1.phoneNumber(e.target.value);
                setWorkPhone(work);
                break;
            case "home_phone_number":
                home = utils_1.phoneNumber(e.target.value);
                setHomePhone(home);
                break;
            case "cell_phone_number":
                cell = utils_1.phoneNumber(e.target.value);
                setCellPhone(cell);
                break;
        }
        props.onChange(home, work, cell, canText, primaryPhone);
    };
    var handleCanTextChange = function (e) {
        var text = e.target.checked;
        setCanText(text);
        props.onChange(homePhone, workPhone, cellPhone, text, primaryPhone);
    };
    var handleChangePrimary = function (e) {
        var primary;
        if (!e.target.checked) {
            primary = null;
        }
        else {
            primary = e.target.name.split("_")[0];
        }
        setPrimaryPhone(primary);
        props.onChange(homePhone, workPhone, cellPhone, canText, primary);
    };
    var renderNumber = function (type) {
        var singleError = (props.display.length === 1) && props.error;
        var singlePhoneLabel = (props.display.length === 1) && props.singlePhoneLabel;
        var values = {
            home: {
                label: strings_1.default.phoneNumbers.labelHome,
                value: homePhone,
                cell: false,
            },
            work: {
                label: strings_1.default.phoneNumbers.labelWork,
                value: workPhone,
                cell: false,
            },
            cell: {
                label: strings_1.default.phoneNumbers.labelCell,
                value: cellPhone,
                cell: true,
            },
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Grid_1.default, { item: true, xs: props.showPrimary ? 9 : 12, sm: values[type].cell ? (props.showPrimary ? 5 : 8) : (props.showPrimary ? 9 : 12), md: values[type].cell ? (props.showPrimary ? 6 : 8) : (props.showPrimary ? 10 : 12) },
                react_1.default.createElement(LimitTextField_1.LimitTextField, { error: singleError, id: (props.name || "pn") + "_" + type + "_phone", key: (props.name || "pn") + "_" + type + "_phone", name: type + "_phone_number", variant: "outlined", size: "small", fullWidth: true, disabled: !!props.readOnly, limit: 16, showCount: false, label: singlePhoneLabel ? strings_1.default.phoneNumbers.labelPhone : values[type].label, value: values[type].value, onChange: handleChangeNumber, onBlur: handleBlurNumber })),
            values[type].cell && (react_1.default.createElement(Grid_1.default, { item: true, xs: 8, sm: 4 },
                react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Checkbox_1.default, { checked: canText, onChange: handleCanTextChange, disabled: !!props.readOnly, name: "cantext", color: "primary" })), label: strings_1.default.phoneNumbers.canText }))),
            !!props.showPrimary && (react_1.default.createElement(Grid_1.default, { item: true, xs: 4, sm: 3, md: 2 },
                react_1.default.createElement(FormControlLabel_1.default, { control: (react_1.default.createElement(Checkbox_1.default, { checked: primaryPhone === type, onChange: handleChangePrimary, disabled: !!props.readOnly, name: type + "_primary_phone", color: "primary" })), label: strings_1.default.phoneNumbers.labelPrimary })))));
    };
    return (react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
        props.display.map(function (d) { return renderNumber(d); }),
        !!props.error && (react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
            react_1.default.createElement("div", { className: classes.error }, (props.showPrimary && !primaryPhone && (homePhone.length || workPhone.length || cellPhone.length)) ? strings_1.default.phoneNumbers.errorMessagePrimary :
                ((props.display.length > 1) ? strings_1.default.phoneNumbers.errorMessageMultiple : strings_1.default.phoneNumbers.errorMessageSingle))))));
};
exports.PhoneNumbers = PhoneNumbers;
